import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../contextStore/AuthContext';
import { savedSearchesRef } from '../../firebase/collections';
import { ToastContext } from '../../contextStore/ToastContext';
import { serverTimestamp } from '../../firebase/collections';
import ButtonSpinner from '../UI/ButtonSpinner';
import './SaveSearch.css';

function SaveSearchModal({ query, filters, onClose, onSuccess }) {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const { addToast } = useContext(ToastContext);
  const [name, setName] = useState('');
  const [notifyOnNew, setNotifyOnNew] = useState(false);
  const [frequency, setFrequency] = useState('daily');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) {
      addToast(t('search.enterSearchName'), 'error');
      return;
    }
    if (!user?.uid) {
      addToast(t('search.loginToSave'), 'error');
      return;
    }
    setLoading(true);
    savedSearchesRef()
      .add({
        userId: user.uid,
        name: trimmed,
        filters: {
          query: query || '',
          category: filters?.category || '',
          subcategory: filters?.subcategory || '',
          minPrice: filters?.minPrice ?? '',
          maxPrice: filters?.maxPrice ?? '',
          state: filters?.state || '',
          city: filters?.city || '',
          condition: filters?.condition || '',
          datePosted: filters?.datePosted || '',
          adType: filters?.adType || '',
        },
        notifyOnNew: Boolean(notifyOnNew),
        frequency: frequency || 'daily',
        isActive: true,
        lastNotified: null,
        createdAt: serverTimestamp(),
      })
      .then(() => {
        addToast(t('search.searchSaved'), 'success');
        onSuccess && onSuccess();
        onClose();
      })
      .catch(() => addToast(t('search.failedToSaveSearch'), 'error'))
      .finally(() => setLoading(false));
  };

  return (
    <div className="saveSearchOverlay" onClick={onClose}>
      <div className="saveSearchModal" onClick={(e) => e.stopPropagation()}>
        <h3>{t('search.saveSearchTitle')}</h3>
        <form onSubmit={handleSubmit}>
          <label>{t('search.searchName')}</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={t('search.searchNamePlaceholder')}
          />
          <label className="saveSearchCheck">
            <input
              type="checkbox"
              checked={notifyOnNew}
              onChange={(e) => setNotifyOnNew(e.target.checked)}
            />
            {t('search.notifyMe')}
          </label>
          {notifyOnNew && (
            <label className="saveSearchFrequency">
              {t('search.frequency')}
              <select value={frequency} onChange={(e) => setFrequency(e.target.value)}>
                <option value="instant">{t('search.instant')}</option>
                <option value="daily">{t('search.daily')}</option>
                <option value="weekly">{t('search.weekly')}</option>
              </select>
            </label>
          )}
          <div className="saveSearchActions">
            <button type="button" onClick={onClose}>
              {t('common.cancel')}
            </button>
            <button type="submit" disabled={loading}>
              {loading && <ButtonSpinner />}{t('common.save')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SaveSearchModal;
